module.exports = __webpack_public_path__ + "img/add_row_before.c8b8b7eb.svg";